import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'close-dialog',
  templateUrl: './close-dialog.component.html',
  styleUrls: ['./close-dialog.component.scss']
})
export class CloseDialogComponent {

  @Input() dialogRef: MatDialogRef<any>;
  @Input() handleOnClose = false;
  @Output() onClose = new EventEmitter<boolean>

  close() {

    if (this.handleOnClose) {
      this.onClose.emit(true);
    } else {
      this.dialogRef.close();
    }
  }
}
